// Q.解約手数料は発生しますか？
const CANCELLATION_FEE_LINK = 'https://tayori.com/q/samurai-terakoya/detail/876066/';

// マンツー導線
const LEAD_TO_PRO_LINK = 'https://lp.sejuku.net/lp1';

// 解約FAQ
const CANCELLATION_FAQ_LINK = 'https://tayori.com/q/samurai-terakoya/category/132768/';

export { CANCELLATION_FEE_LINK, LEAD_TO_PRO_LINK, CANCELLATION_FAQ_LINK };
